export const DOMAINS = {
  PORTAL_ENEAS_NO: 'portal.eneas.no',
  PORTAL_DEV_ENEAS_NO: 'portal-dev.eneas.no',
  PORTAL_ENEAS_SE: 'portal.eneas.se',
  PORTAL_DEV_ENEAS_SE: 'portal-dev.eneas.se',
  PORTAL_NORDELENERGI_SE: 'portal.nordelenergi.se',
  PORTAL_DEV_NORDELENERGI_SE: 'portal-dev.nordelenergi.se',
  PORTAL_VENIENERGY_FI: 'portal.venienergia.fi',
  PORTAL_DEV_VENIENERGY_FI: 'portal-dev.venienergia.fi',
  PORTAL_GU_VENI_DE: 'portal.gu-veni.de',
  PORTAL_DEV_GU_VENI_DE: 'portal-dev.gu-veni.de',
} as const;

export type Domain = (typeof DOMAINS)[keyof typeof DOMAINS];

export const isDomain = (maybeDomain: string): maybeDomain is Domain =>
  Object.values(DOMAINS).includes(maybeDomain as Domain);

export const BRAND = {
  NO_ENEAS: 'NO_ENEAS',
  SE_ENEAS: 'SE_ENEAS',
  SE_NORDEL: 'SE_NORDEL',
  FI_VENI: 'FI_VENI',
  DE_VENI: 'DE_VENI',
} as const;

export type Brand = (typeof BRAND)[keyof typeof BRAND];

export const BRAND_TYPE_FROM_BFF = {
  EneasNorway: 'EneasNorway',
  EneasSweden: 'EneasSweden',
  YSHFinland: 'YSHFinland',
  VeniFinland: 'VeniFinland',
  NordelEnergiSweden: 'NordelEnergiSweden',
  NordelEnergiNorway: 'NordelEnergiNorway',
  GreeneFinland: 'GreeneFinland',
  GUGermany: 'GUGermany',
  NovaluzSpain: 'NovaluzSpain',
} as const;

export type BrandTypeFromBff = (typeof BRAND_TYPE_FROM_BFF)[keyof typeof BRAND_TYPE_FROM_BFF];

const BRAND_TO_I18N_KEY = {
  [BRAND.NO_ENEAS]: 'eneas',
  [BRAND.SE_ENEAS]: 'eneas',
  [BRAND.SE_NORDEL]: 'nordel',
  [BRAND.FI_VENI]: 'veni',
  [BRAND.DE_VENI]: 'veni',
} as const;

export type I18nBrandKey = (typeof BRAND_TO_I18N_KEY)[Brand];

export const getI18nBrandKey = (brand: Brand): I18nBrandKey => BRAND_TO_I18N_KEY[brand];

export const BRAND_DOMAIN: Record<Brand, Domain[]> = {
  [BRAND.NO_ENEAS]: [DOMAINS.PORTAL_ENEAS_NO, DOMAINS.PORTAL_DEV_ENEAS_NO],
  [BRAND.SE_ENEAS]: [DOMAINS.PORTAL_ENEAS_SE, DOMAINS.PORTAL_DEV_ENEAS_SE],
  [BRAND.SE_NORDEL]: [DOMAINS.PORTAL_NORDELENERGI_SE, DOMAINS.PORTAL_DEV_NORDELENERGI_SE],
  [BRAND.FI_VENI]: [DOMAINS.PORTAL_VENIENERGY_FI, DOMAINS.PORTAL_DEV_VENIENERGY_FI],
  [BRAND.DE_VENI]: [DOMAINS.PORTAL_GU_VENI_DE, DOMAINS.PORTAL_DEV_GU_VENI_DE],
} as const;

export const BRAND_TO_BFF: Record<Brand, BrandTypeFromBff> = {
  [BRAND.FI_VENI]: BRAND_TYPE_FROM_BFF.VeniFinland,
  [BRAND.NO_ENEAS]: BRAND_TYPE_FROM_BFF.EneasNorway,
  [BRAND.SE_ENEAS]: BRAND_TYPE_FROM_BFF.EneasSweden,
  [BRAND.SE_NORDEL]: BRAND_TYPE_FROM_BFF.NordelEnergiSweden,
  [BRAND.DE_VENI]: BRAND_TYPE_FROM_BFF.GUGermany,
};

export type BrandContact = {
  phone: string;
  email: string;
};

// Contact details belong to the brand, not the visitor's locale, so they must not be duplicated per language.
export const BRAND_CONTACT: Record<Brand, BrandContact> = {
  [BRAND.NO_ENEAS]: { phone: '+47 32 24 26 80', email: 'kraft@eneas.no' },
  [BRAND.SE_ENEAS]: { phone: '0152- 122 80', email: 'kundservice@eneasservices.se' },
  [BRAND.SE_NORDEL]: { phone: '+46 73 421 7676', email: 'kundservice@nordelenergi.se' },
  [BRAND.FI_VENI]: { phone: '+358 20 741 4110', email: 'asiakaspalvelu@venienergia.fi' },
  [BRAND.DE_VENI]: { phone: '+49 69 - 407 666 20', email: 'service@gu-veni.de' },
};
